module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7301/images/default-avatar.png"